import React, { createContext, useContext } from 'react'

const noop = () => {}

export const ToastContext = createContext(noop)

export function ToastProvider({ pushToast = noop, children }) {
  return (
    <ToastContext.Provider value={pushToast}>
      {children}
    </ToastContext.Provider>
  )
}

export function useToast() {
  return useContext(ToastContext)
}
